import Vue from 'vue'

import Vuex from 'vuex'

import {mai} from '../../../../utils/buried'

Vue.use(Vuex)
import { getCoin } from '../api/index'
export default new Vuex.Store({
    state: {
        popflag: false,
        poptype: 0,
        successflag: false,
        coin: 0, // 小谷币的个数
        convertType: 0, //兑换礼品类型
        consumenum: 0, //消耗小谷币的个数
        prizename: "" //奖品名称
    },
    mutations: {
        Openpop(state, type) {
            state.popflag = true
            state.poptype = type
        },
        Closepop(state) {
            state.popflag = false
        },
        Opensuccesspop(state) {
            state.successflag = true
        },
        Closesuccesspop(state) {
            state.successflag = false
        },
        Opennomore(state) {
            state.poptype = 4
            state.successflag = true
        },
        Openbigdata(state) {
            state.poptype = 7
            state.successflag = true
        },
        Openmore(state, { consumenum, convertType }) {
            state.consumenum = consumenum
            state.convertType = convertType
            switch (convertType) {
                case 0:
                    state.prizename = "iphone 12 pro"
                    break;
                case 1:
                    state.prizename = "apple airpods"
                    break;
                case 2:
                    state.prizename = "500元京东购物卡"
                    break;
                case 3:
                    state.prizename = "300元京东购物卡"
                    break;
                case 4:
                    state.prizename = "传智播客原版教材"
                    break;
                case 5:
                    state.prizename = "定制优美U盘"
                    break;
                case 6:
                    state.prizename = "U型枕"
                    break;
                case 7:
                    state.prizename = "播仔桌垫"
                    break;
            }
            state.poptype = 5
            state.successflag = true
            mai(2,null,`兑换好礼(${state.prizename})`)
        }
    },
    actions: {
        //获取小谷币
        async getCoin({ commit, state }) {
            let uid = localStorage.getItem("uid");
            let sign = localStorage.getItem("sign")
            // 如果登录
            if (uid && sign) {
                // 获取当前小谷币
                const data = await getCoin({
                    activityId: "may_S5C81THFGYKZ",
                    userId: uid,
                    activityType: 1,
                }, sign);
                // 如果失败可能是uid过期 就重新登录
                if (!data.success) {
                    commit("Openpop", 4)
                    return Promise.resolve(false)
                } else {
                    state.coin = data.data.balancePoints
                    return Promise.resolve(true)
                }
            } else {
                // 否则登录
                commit("Openpop", 4)
                return Promise.resolve(false)
            }
        },
        async getCoin2({ commit, state }) {
            let uid = localStorage.getItem("uid");
            let sign = localStorage.getItem("sign")
            // 获取当前小谷币
            const data = await getCoin({
                activityId: "may_S5C81THFGYKZ",
                userId: uid,
                activityType: 1,
            }, sign);
            // 如果失败可能是uid过期 就重新登录
            if (!data.success) {
                return Promise.resolve(false)
            } else {
                state.coin = data.data.balancePoints
                return Promise.resolve(true)
            }
        }
    }
})

